/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './data-table-column.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../@angular/material/typings/index.ngfactory';
import * as i3 from '@angular/material';
import * as i4 from '@angular/common';
import * as i5 from '@covalent/core/data-table/data-table-column/data-table-column.component';
const styles_TdDataTableColumnComponent:any[] = [i0.styles];
export const RenderType_TdDataTableColumnComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_TdDataTableColumnComponent,data:{}});
function View_TdDataTableColumnComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-icon',[['class',
      'td-data-table-sort-icon'],['role','img']],[[2,'mat-asc',(null as any)],[2,'mat-desc',
      (null as any)],[2,'mat-icon',(null as any)]],[[(null as any),'click']],(_v,en,
      $event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>(_co.sortable && _co.handleSortBy())) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },i2.View_MdIcon_0,i2.RenderType_MdIcon)),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,
      [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(9027584,(null as any),0,i3.MdIcon,[i1.ElementRef,i1.Renderer2,i3.MdIconRegistry],
          (null as any),(null as any)),(_l()(),i1.ɵted(0,['\n  arrow_upward\n']))],
      (_ck,_v) => {
        _ck(_v,2,0);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:boolean = (!_co.active || _co.isAscending());
        const currVal_1:any = (_co.active && _co.isDescending());
        const currVal_2:any = true;
        _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
      });
}
function View_TdDataTableColumnComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-icon',[['class',
      'td-data-table-sort-icon'],['role','img']],[[2,'mat-asc',(null as any)],[2,'mat-desc',
      (null as any)],[2,'mat-icon',(null as any)]],[[(null as any),'click']],(_v,en,
      $event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>(_co.sortable && _co.handleSortBy())) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },i2.View_MdIcon_0,i2.RenderType_MdIcon)),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,
      [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(9027584,(null as any),0,i3.MdIcon,[i1.ElementRef,i1.Renderer2,i3.MdIconRegistry],
          (null as any),(null as any)),(_l()(),i1.ɵted(0,['\n  arrow_upward\n']))],
      (_ck,_v) => {
        _ck(_v,2,0);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:boolean = (!_co.active || _co.isAscending());
        const currVal_1:any = (_co.active && _co.isDescending());
        const currVal_2:any = true;
        _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
      });
}
export function View_TdDataTableColumnComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_TdDataTableColumnComponent_1)),i1.ɵdid(16384,(null as any),0,i4.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),
      ['\n'])),(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'span',[['class','md-caption']],
      (null as any),[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i5.TdDataTableColumnComponent = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>(_co.sortable && _co.handleSortBy())) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n  '])),i1.ɵncd((null as any),
      0),(_l()(),i1.ɵted((null as any),['\n'])),(_l()(),i1.ɵted((null as any),['\n'])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_TdDataTableColumnComponent_2)),
      i1.ɵdid(16384,(null as any),0,i4.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any))],(_ck,_v) => {
    var _co:i5.TdDataTableColumnComponent = _v.component;
    const currVal_0:any = (_co.sortable && _co.numeric);
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = (_co.sortable && !_co.numeric);
    _ck(_v,9,0,currVal_1);
  },(null as any));
}
export function View_TdDataTableColumnComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'th',[['td-data-table-column',
      '']],[[2,'mat-clickable',(null as any)],[2,'mat-sortable',(null as any)],[2,
      'mat-active',(null as any)],[2,'mat-numeric',(null as any)]],(null as any),(null as any),
      View_TdDataTableColumnComponent_0,RenderType_TdDataTableColumnComponent)),i1.ɵdid(49152,
      (null as any),0,i5.TdDataTableColumnComponent,[i1.ElementRef,i1.Renderer2],(null as any),
      (null as any))],(null as any),(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).bindClickable;
    const currVal_1:any = i1.ɵnov(_v,1).bingSortable;
    const currVal_2:any = i1.ɵnov(_v,1).bindActive;
    const currVal_3:any = i1.ɵnov(_v,1).bindNumeric;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3);
  });
}
export const TdDataTableColumnComponentNgFactory:i1.ComponentFactory<i5.TdDataTableColumnComponent> = i1.ɵccf('th[td-data-table-column]',
    i5.TdDataTableColumnComponent,View_TdDataTableColumnComponent_Host_0,{name:'name',
        sortable:'sortable',active:'active',numeric:'numeric',sortOrder:'sortOrder'},
    {onSortChange:'sortChange'},['*']);
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/~/@covalent/core/data-table/data-table-column/data-table-column.component.ngfactory.ts